const testimonials = [
  {
    quote: 'Honestly, if I got up out of my chair and started a new job somewhere else at another medical facility tomorrow, and they were looking for a solution, I would just give you guys a call. I probably wouldn\'t even shop.',
    name: 'Adam Frank',
    company: 'ENT Salem',
    length: 'long',
  },
  {
    quote: 'Our staff was spending countless hours each day manually reading, typing, and uploading faxes to where they belong. Using Medsender, we can free our staff from these repetitive steps and ensure we schedule patients for care faster than ever before and receive the most efficient care possible.',
    name: 'Ahmad Malik',
    company: 'CORA Physical Therapy',
    length: 'long',
  },
  {
    quote: 'Everything about Medsender is user-friendly. It is one of the best products I have used, and I\'ve used a lot through the years.',
    name: 'Tracy Shumate',
    company: 'Triad Behavioral Resources',
  },
  {
    quote: 'All said, we save at least thirty minutes of working time, per person, per day, and we have between three and five employees per office. One of our offices gets bombarded daily with faxes from the hospitals they work with. That is a lot of pages we don\'t have to print or process manually.',
    name: 'Michelle Harper',
    company: 'Prosthetics & Orthotics Group',
    length: 'long',
  },
  {
    quote: 'We\'ve seen an all-around practice efficiency improvement after implementing Medsender. We couldn\'t be happier!',
    name: 'Andi Manrique',
    title: 'Practice Manager',
    company: 'Crescent Beach Care',
  },
  {
    quote: 'Everyone should be using this! We\'ve saved thousands of dollars each month.',
    name: 'Adrian Long',
    company: 'Crescent Beach Care',
  },
  {
    quote: 'If I started a new job at another medical facility tomorrow, I would just give Medsender a call. I would not even shop.',
    name: 'Adam Frank',
    company: 'Willamette ENT Salem',
  },
  {
    quote: 'With Medsender, in most cases we are now able to do same-day referral processing.',
    name: 'Carly Mathena',
    company: 'Frontier Dermatology',
  },
  {
    quote: 'We are extremely pleased with the technology and effectiveness of Medsender. Further, the team at Medsender was amazing to work with. They were attentive and responsive to our needs. We cannot speak highly enough of what Medsender brings to the table.',
    name: 'Brian May',
    title: 'Dir. of Healthcare Business',
    company: 'Frontier Derm',
    length: 'long',
  },
  {
    quote: 'Efficient and cost-effective, it provides peace of mind and saves you countless hours and thousands of dollars.',
    name: 'Jared Purvis',
    company: 'Adapt Therapy',
  },
  {
    quote: 'We now process all our referrals the same day and schedule 50% within minutes. That\'s not just faster revenue; it\'s more revenue.',
    name: 'Noah England',
    title: 'Chief Operating Officer',
    company: 'Piedmont Plastic Surgery & Dermatology',
  },
  {
    quote: 'Medsender helps us make sure no fax or referral gets left behind. It has been a game changer for our office.',
    name: 'Colleen McCoy',
    title: 'Clinical Coordinator',
    company: 'Midwest Derm',
  },
  {
    quote: 'Now it\'s all centralized. Everyone from their own desk can pull up Medsender and search for referral by name and DOB and I think it\'s heavenly.',
    name: 'Hazel Jackson',
    title: 'Practice Manager',
    company: 'Pinon Hills ENT',
  },
  {
    quote: 'Having Medsender automatically read, categorize, and prioritize them while putting them in the right queues is extremely helpful for us. If we lost Medsender, this entire workflow would be lost as well.',
    name: 'Joe Atzenbeck',
    title: 'Chief Executive Officer',
    company: 'The Clinic for Dermatology & Wellness',
    length: 'long',
  },
];

export default testimonials;
